import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import { MessageSquare, ChevronDown, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import { API } from "../../lib/api";

const AdminContacts = () => {
  const { authHeaders } = useOutletContext();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/admin/contacts`, { headers: authHeaders })
      .then((r) => setItems(r.data))
      .catch(() => toast.error("Laden mislukt"))
      .finally(() => setLoading(false));
  }, [authHeaders]);

  return (
    <div data-testid="admin-contacts-page" className="border border-[var(--tha-border)] bg-[#0a0a0a]">
      <div className="px-5 py-4 border-b border-[var(--tha-border)] flex items-center gap-2">
        <MessageSquare size={14} className="text-[var(--tha-red)]" />
        <span className="text-xs font-mono-x tracking-widest text-white">CONTACTBERICHTEN</span>
        <span className="ml-auto text-xs text-[var(--tha-muted)]">{items.length} berichten</span>
      </div>

      {loading ? (
        <div className="p-12 text-center text-sm text-[var(--tha-muted)]">Laden...</div>
      ) : items.length === 0 ? (
        <div className="p-12 text-center text-sm text-[var(--tha-muted)]">
          Nog geen berichten.
        </div>
      ) : (
        <ul>
          {items.map((c) => {
            const isOpen = expanded === c.id;
            return (
              <li
                key={c.id}
                data-testid={`contact-row-${c.id}`}
                className="border-b border-[var(--tha-border)] last:border-0"
              >
                <button
                  onClick={() => setExpanded(isOpen ? null : c.id)}
                  className="w-full px-5 py-4 flex items-center gap-4 hover:bg-[#111] text-left"
                >
                  {isOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                  <div className="flex-1 min-w-0 grid grid-cols-1 sm:grid-cols-3 gap-2">
                    <div className="text-sm text-white truncate">{c.name}</div>
                    <div className="text-sm text-[var(--tha-muted)] truncate">
                      {c.subject || "—"}
                    </div>
                    <div className="text-xs text-[var(--tha-muted)] font-mono-x text-right">
                      {new Date(c.created_at).toLocaleString("nl-NL")}
                    </div>
                  </div>
                </button>

                {isOpen && (
                  <div className="px-5 pb-5 bg-[#070707]">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                      <div>
                        <span className="text-[var(--tha-muted)]">Van: </span>
                        <a
                          href={`mailto:${c.email}?subject=Re: ${encodeURIComponent(c.subject || "Tik Hem Aan!")}`}
                          className="text-[var(--tha-red)] hover:underline"
                        >
                          {c.email}
                        </a>
                      </div>
                      <div>
                        <span className="text-[var(--tha-muted)]">Onderwerp: </span>
                        <span className="text-white">{c.subject || "—"}</span>
                      </div>
                    </div>
                    <div className="mt-4 p-4 border-l-2 border-[var(--tha-red)] bg-[#0a0a0a] whitespace-pre-wrap text-sm text-white">
                      {c.message}
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default AdminContacts;
